import script from "./title.vue?vue&type=script&lang=js"
export * from "./title.vue?vue&type=script&lang=js"

import "./title.vue?vue&type=style&index=0&id=2d93b71a&lang=scss"

const __exports__ = script;

export default __exports__